module.exports = __webpack_public_path__ + "static/img/greTyong.a142489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/greTyong.png
// module id = FOPZ
// module chunks = 23